import { PriorityFilterEnum } from "app/types";
import React from "react";

// Components
import EffortEstimated from "app/containers/Features/containers/Boards/containers/Tickets/TicketFields/ColumnCustomize/EffortEstimated";
import { GroupByTypeEnum } from "../../../../types";
import { ITickets } from "../../types";
import AssigneeSelection from "./Assignee";
import CreatedDate from "./CreatedDate";
import Creator from "./Creator";
import DueDateSelection from "./DueDateSelection";
import EffortActual from "./EffortActual";
import Priority from "./Priority";
import StatusSelection from "./Status";
import TagSelection from "./TagSelection";
import TicketId from "./TicketId";
import TicketTypeSelection from "./TicketTypeSelection";
import { EffortEstimatedType } from "app/containers/Features/types";

interface Props {
  field: GroupByTypeEnum;
  ticket: ITickets;
  onUpdate: (field: GroupByTypeEnum, value: any, extra?: any) => void;
}

const FieldRenderer: React.FC<Props> = ({ field, ticket, onUpdate }) => {
  switch (field) {
    case GroupByTypeEnum.TAGS:
      return (
        <TagSelection
          tagIds={ticket.tags}
          onUpdate={(tags, action) => {
            onUpdate(field, tags, action);
          }}
        />
      );

    case GroupByTypeEnum.ASSIGNEE:
      return (
        <AssigneeSelection
          assignedTo={ticket.assignedTo}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );

    case GroupByTypeEnum.STATUS:
      return (
        <StatusSelection
          ticket={ticket}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );

    case GroupByTypeEnum.TICKET_TYPE:
      return (
        <TicketTypeSelection
          value={ticket.type}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );

    case GroupByTypeEnum.PRIORITY:
      return (
        <Priority
          value={ticket.priority as PriorityFilterEnum}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );

    case GroupByTypeEnum.DUE_DATE:
      return (
        <DueDateSelection
          value={ticket.dueDate}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );

    case GroupByTypeEnum.TICKET_ID:
      return <TicketId value={ticket.ticketID} />;

    case GroupByTypeEnum.CREATOR:
      return <Creator value={ticket.createdBy} />;

    case GroupByTypeEnum.CREATED_DATE:
      return <CreatedDate value={ticket.createdDate} />;

    case GroupByTypeEnum.EFFORTS_ESTIMATION:
      return (
        <EffortEstimated
          ticketDetail={ticket}
          onUpdate={(effortEstimated: EffortEstimatedType) =>
            onUpdate(field, [effortEstimated])
          }
        />
      );

    case GroupByTypeEnum.EFFORT_ACTUAL:
      return <EffortActual ticketDetail={ticket} />;

    default:
      return null;
  }
};

export default FieldRenderer;
